export const getContrastYIQ = (hexColor: string) => {
  // eslint-disable-next-line id-length
  const [r, g, b] = [0, 2, 4].map((position) =>
    parseInt(hexColor.replace(/^#/, '').slice(position, position + 2), 16)
  );
  return (r * 299 + g * 587 + b * 114) / 1000 >= 128;
};
